module.exports = __webpack_public_path__ + "static/img/home-new2.b10d52c2.jpeg";